export default __webpack_public_path__ + "static/media/deleteduser.cedba5e1.svg";